import { GraphViewType, VisDataSet, VisEdge } from '../types';
import getRelatedNodes from './getRelatedNodes';

interface Arguments {
  draggedNodeIds: string[];
  graphType: GraphViewType;
  isDragStart: boolean;
  isMovingConnected?: boolean;
  edges: VisEdge[];
  graphNodes?: VisDataSet;
  network: any;
}

const lockAll = (graphNodes?: VisDataSet) => {
  const ids = graphNodes?.getIds() as string[];
  graphNodes?.update(ids.map((id) => ({ id, fixed: true })));
};

const dragWithPhysics = (
  modifiedNodeIds: string[],
  { draggedNodeIds, graphNodes, isDragStart, isMovingConnected }: Arguments
): string[] => {
  const unlock = isDragStart && isMovingConnected;
  const movedNodes: string[] = [];
  modifiedNodeIds.forEach((id) => {
    if (
      graphNodes?.get(id) &&
      (!isDragStart || draggedNodeIds.indexOf(id) === -1)
    ) {
      graphNodes?.update({ id, fixed: !unlock });
      movedNodes.push(id);
    }
  });
  return movedNodes;
};

const dragFixed = (
  modifiedNodeIds: string[],
  {
    draggedNodeIds,
    graphNodes,
    isDragStart,
    isMovingConnected,
    network,
  }: Arguments
): string[] => {
  const validNodes = modifiedNodeIds.filter((id) => graphNodes?.get(id));
  if (isDragStart && isMovingConnected) {
    const movedNodes = [...draggedNodeIds, ...validNodes];
    lockAll(graphNodes);
    network.selectNodes([...draggedNodeIds, ...validNodes], false);
    graphNodes?.update(movedNodes.map((id) => ({ id, fixed: false })));
    return validNodes;
  } else if (!isDragStart) {
    lockAll(graphNodes);
    network.selectNodes([]);
  }
  return draggedNodeIds;
};

// Returns an array of the modified node ids
const handleDragWithRelatedNodes = (args: Arguments): string[] => {
  const modifiedNodeIds: string[] = args.draggedNodeIds.flatMap((id) =>
    getRelatedNodes(id, args.edges)
  );
  const movedNodes: string[] =
    args.graphType === GraphViewType.mesh
      ? dragWithPhysics(modifiedNodeIds, args)
      : dragFixed(modifiedNodeIds, args);

  return [...args.draggedNodeIds, ...movedNodes];
};

export default handleDragWithRelatedNodes;
